import { useEffect } from "react";
import { Navigate, useNavigate, useRoutes } from "react-router-dom";

import useStore from "../store/useStore";
// ================= PAGE ROUTING ================== //
import Page404 from "@/pages/404";
import Dashboard from "../pages/dashboard";
import LoginPage from "../pages/login";
import MasterAccount from "../pages/Master/account";
import MasterEmployee from "../pages/Master/employee";
import MasterDealer from "../pages/Master/dealer";
import MasterPiutang from "../pages/Master/piutang";
import MasterAnggota from "../pages/Master/anggota";
import InhousePage from "../pages/Transaksi/inhouse";
import OrderList from "../pages/Transaksi/orderlist";
import OrderListDF from "../pages/Transaksi/orderlistDF";
import SekretarisPage from "../pages/Transaksi/sekre";
import ReportInhousePage from "../pages/Report/inhouse";

import Logout from "../pages/logout";
import ReportJurnalPage from "../pages/Report/jurnal";
import ReportNecaraSaldoPage from "../pages/Report/neracaSaldo";
import ReportBukuBesarPage from "../pages/Report/bukuBesar";
import ApprovalDetailPage from "../pages/approvalDetail";
import ApprovalDealerDetailPage from "../pages/Master/dealer/detail";

import DocumentCheckingPage from "../pages/documentChecking";
import ApplicationInquiry from "../pages/Transaksi/inquiry";
import MasterCabang from "../pages/Master/cabang";
import AuditTrail from "../pages/Master/auditTrail";

const Routes = () => {
  const navigate = useNavigate();
  const { isLoggedIn } = useStore();

  const isLogin = useStore((state) => state.isLoggedIn);

  const tokenExist = isLogin;

  useEffect(() => {
    if (window.location.pathname === "/" && !tokenExist) {
      navigate("/login");
    } else {
      navigate("/dashboard");
    }
  }, [isLogin]);

  console.log(tokenExist);

  function ProtectedRoute({ token, children }) {
    if (token == false) {
      return <Navigate to="/login" replace />;
    }

    return children;
  }

  // Config router
  const routesConfig = [
    // page login
    { path: "/login", element: <LoginPage /> },

    // page after login
    { path: "/dashboard", element: <Dashboard />, protected: true },
    { path: "/audit-trail", element: <AuditTrail />, protected: true },
    // { path: "/master-acc", element: <MasterAccount />, protected: true },
    // { path: "/master-acc", element: <MasterAccount />, protected: true },
    { path: "/master-branch", element: <MasterCabang />, protected: true },
    { path: "/master-emp", element: <MasterEmployee />, protected: true },
    { path: "/master-dealer", element: <MasterDealer />, protected: true },
    { path: "/master-piutang", element: <MasterPiutang />, protected: true },
    { path: "/master-anggota", element: <MasterAnggota />, protected: true },
    { path: "/sekre", element: <SekretarisPage />, protected: true },
    // { path: "/logout", element: <Logout />, protected: true },

    // page aprovoval
    { path: "/approval", element: <InhousePage />, protected: true },
    { path: "/orderlist", element: <OrderList />, protected: true },
    { path: "/orderlist-DF", element: <OrderListDF />, protected: true },
    { path: "/inquiry", element: <ApplicationInquiry />, protected: true },
    { path: "/doc-check", element: <DocumentCheckingPage />, protected: true },

    // {
    //   path: "/approval/detail/:id",
    //   element: <ApprovalDetailPage />,
    //   protected: true,
    // },

    {
      path: "/approval/detail/:application_id/:nik",
      element: <ApprovalDetailPage />,
      protected: true,
    },

    {
      path: "/dealer/detail/:id/",
      element: <ApprovalDealerDetailPage />,
      protected: true,
    },

    // page report
    {
      path: "/report/jurnal",
      element: <ReportJurnalPage />,
      protected: true,
    },
    {
      path: "/report/neraca-saldo",
      element: <ReportNecaraSaldoPage />,
      protected: true,
    },
    {
      path: "/report/buku-besar",
      element: <ReportBukuBesarPage />,
      protected: true,
    },

    // page 404
    { path: "*", element: <Page404 /> },
  ];

  const routes = routesConfig.map(
    ({ path, element, protected: isProtected }) => ({
      path,
      element: isProtected ? (
        <ProtectedRoute token={tokenExist}>{element}</ProtectedRoute>
      ) : (
        element
      ),
    })
  );

  const element = useRoutes(routes);

  // const element = useRoutes([
  //   { path: "/login", element: <LoginPage /> },

  //   {
  //     path: "/dashboard",
  //     element: (
  //       <ProtectedRoute token={tokenExist}>
  //         <Dashboard />
  //       </ProtectedRoute>
  //     ),
  //   },

  //   // Master
  //   {
  //     path: "/master-acc",
  //     element: (
  //       <ProtectedRoute token={tokenExist}>
  //         <MasterAccount />
  //       </ProtectedRoute>
  //     ),
  //   },
  //   {
  //     path: "/master-emp",
  //     element: (
  //       <ProtectedRoute token={tokenExist}>
  //         <MasterEmployee />
  //       </ProtectedRoute>
  //     ),
  //   },
  //   {
  //     path: "/master-piutang",
  //     element: (
  //       <ProtectedRoute token={tokenExist}>
  //         <MasterPiutang />
  //       </ProtectedRoute>
  //     ),
  //   },
  //   {
  //     path: "/master-anggota",
  //     element: (
  //       <ProtectedRoute token={tokenExist}>
  //         <MasterAnggota />
  //       </ProtectedRoute>
  //     ),
  //   },

  //   // Transaksi
  //   {
  //     path: "/inhouse",
  //     element: (
  //       <ProtectedRoute token={tokenExist}>
  //         <InhousePage />
  //       </ProtectedRoute>
  //     ),
  //   },
  //   {
  //     path: "/sekre",
  //     element: (
  //       <ProtectedRoute token={tokenExist}>
  //         <SekretarisPage />
  //       </ProtectedRoute>
  //     ),
  //   },

  //   {
  //     path: "/logout",
  //     element: (
  //       <ProtectedRoute token={tokenExist}>
  //         <Logout />
  //       </ProtectedRoute>
  //     ),
  //   },

  //   { path: "*", element: <Page404 /> },

  //   // {
  //   //   path: "/dashboard",
  //   //   element: (
  //   //     <ProtectedRoute token={tokenExist}>
  //   //       <Dashboard />
  //   //     </ProtectedRoute>
  //   //   ),
  //   // },
  // ]);

  return element;
};

export default Routes;
